<template>
  <span>
    <settings-panel :open="settingsOpen" @close="settingsOpen = false" />

    <div
      class="dacb-chat-header"
      :style="{ backgroundColor: options.primaryColour, color: `${options.textColour} !important` }"
    >
      <div v-if="conversation.test_mode" class="dacb-test-mode">
        <span>{{ $t("testMode") }}</span>
      </div>

      <div
        v-show="settingsVisible"
        class="dacb-settings"
        :class="{ '-open': settingsOpen }"
        @click="settingsOpen = !settingsOpen"
      >
        <svg viewBox="0 0 32 32">
          <path
            d="M30,17.999V14h-4.201c-0.25-1.227-0.729-2.368-1.383-3.386l2.998-2.999l-2.83-2.828l-2.953,2.952   C20.553,7.002,19.324,6.47,18,6.201V2h-4v4.201c-1.277,0.26-2.463,0.765-3.512,1.459L7.614,4.787L4.785,7.614l2.874,2.876   C6.965,11.539,6.46,12.724,6.201,14H2v4h4.202c0.269,1.324,0.801,2.553,1.538,3.631l-2.954,2.953l2.83,2.83l2.998-2.999   c1.019,0.654,2.16,1.134,3.387,1.384V30h3.999v-4.201c1.276-0.26,2.463-0.764,3.512-1.459l3.073,3.074l2.83-2.83l-3.074-3.073   c0.694-1.05,1.199-2.235,1.458-3.512H30z M16,21.999c-3.313-0.006-5.994-2.688-6.001-5.999c0.008-3.313,2.688-5.994,6.001-6   c3.312,0.006,5.993,2.686,5.999,6C21.993,19.312,19.312,21.993,16,21.999z"
            :style="{ fill: options.textColour }"
          />
        </svg>
      </div>

      <div class="dacb-title">
        <span class="img" :class="{ '-hidden': !image }" :style="{ backgroundImage: 'url(' + image + ')' }"></span>
        <p :style="{ color: `${options.textColour} !important` }">{{ title }}</p>
      </div>

      <div v-show="showClose" class="dacb-close-cross" :style="{ color: options.textColour }" @click="close">x</div>
    </div>
  </span>
</template>

<script>
import SettingsPanel from "components/SettingsPanel.vue";
import bus from "helpers/bus";
import { mapState } from "vuex";

export default {
  name: "ChatHeader",

  components: { SettingsPanel },

  data() {
    return {
      settingsOpen: false,
      showClose: true
    };
  },

  computed: {
    ...mapState({
      customer: (state) => state.customer.current,
      conversation: (state) => state.conversation.current,
      options: (state) => state.options.options
    }),

    title() {
      return this.conversation.metadata.context.title || this.$t("liveChat");
    },

    image() {
      return this.conversation.metadata.context.image;
    },

    settingsVisible() {
      return this.customer.name && this.customer.name.length > 0;
    }
  },

  mounted() {
    this.showClose = !this.options.embedded;
  },

  methods: {
    close() {
      bus.$emit("close");
    }
  }
};
</script>
